import _ from 'lodash'

function getFromAddress (order) {
  return (
    order &&
    _.compact([
      order.fromAddress1,
      order.fromAddress2,
      order.fromDistrict,
      order.fromCity,
      order.fromState,
      order.fromCountry,
      order.fromPostcode
    ]).join(', ')
  )
}

function getToAddress (order) {
  return (
    order &&
    _.compact([
      order.toAddress1,
      order.toAddress2,
      order.toDistrict,
      order.toCity,
      order.toState,
      order.toCountry,
      order.toPostcode
    ]).join(', ')
  )
}

function getName (data) {
  return _.get(data, 'name')
}

function getFormattedAddress (data) {
  return _.get(data, 'formattedAddress')
}

function getLatitude (data) {
  return _.result(data, 'geometry.location.lat.toString')
}

function getLongitude (data) {
  return _.result(data, 'geometry.location.lng.toString')
}

const getAddressComponentByType = (data, type, text = 'longName') => {
  if (data) {
    for (const c of data.addressComponents) {
      if (_.includes(c.types, type)) {
        return _.get(c, text)
      }
    }
  } else {
    return null
  }
}

function getCountry (data) {
  return getAddressComponentByType(data, 'country', 'shortName')
}

function getPostcode (data) {
  return getAddressComponentByType(data, 'postal_code')
}

function mapAddress (data) {
  return {
    address1: getFormattedAddress(data),
    latitude: getLatitude(data),
    longitude: getLongitude(data),
    postcode: getPostcode(data),
    country: getCountry(data)
  }
}

export default {
  getFromAddress,
  getToAddress,
  getName,
  getLatitude,
  getLongitude,
  getCountry,
  getPostcode,
  mapAddress
}
